import type { UseQueryOptions } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../api";
import urls from "../../urls";
import type { TQuicksearchResponse } from "./Quicksearch.types";

export function quickSearchQuery() {
  return queryOptions<TQuicksearchResponse>({
    queryKey: ["quickSearch"],
    queryFn: fetchQuickSearch,
    staleTime: 10000
  });
}

export function useQuicksearch(
  options?: Partial<UseQueryOptions<TQuicksearchResponse>> | undefined
) {
  return useQuery({
    ...quickSearchQuery(),
    ...options
  });
}

async function fetchQuickSearch() {
  const response = await apiWithoutCamelization.get<TQuicksearchResponse>(
    urls.apiWithoutCamelization.quickSearch()
  );
  return response.data;
}
